import { Controller } from '@hotwired/stimulus'

// Soft hints for local delivery window based on readiness choice.
export default class extends Controller {
  static targets = ['readiness', 'localHint', 'outOfCityWindow', 'outOfCityCod']

  connect () {
    this.syncHints()
    this.syncOutOfCityCod()
  }

  syncHints () {
    if (!this.hasLocalHintTarget) return

    const selected = this.readinessTargets.find((input) => input.checked)
    const value = selected?.value || 'ready_to_ship'

    this.localHintTarget.textContent = value === 'needs_preparation'
      ? 'Suggested: 1–2 or 2–3 days (prep first, then local deliver).'
      : 'Suggested: same day or within a few hours for nearby buyers.'
  }

  syncOutOfCityCod () {
    if (!this.hasOutOfCityCodTarget) return

    const select = this.hasOutOfCityWindowTarget
      ? this.outOfCityWindowTarget
      : this.element.querySelector('[data-delivery-promise-target="outOfCityWindow"]')
    const value = select?.value || 'not_available'
    const available = value !== 'not_available'
    this.outOfCityCodTarget.classList.toggle('hidden', !available)
  }
}
